export function getMotion(mode, motion, defaultMotions) {
    if (motion) {
        return motion;
    }
    if (defaultMotions) {
        return defaultMotions[mode] || defaultMotions.other;
    }
    return undefined;
}
